import type { AppBootstrap } from "./types";
import { apiFetch } from "@/shared/api/http";

interface ApiBootstrap {
  identity: { id: string; nome: string; emailMascarado: string; fotoUrl?: string | null };
  activeContextId: string;
  contexts: Array<{
    id: string; tenantId: string; tenantNome: string; experiencia: AppBootstrap["contexts"][number]["experience"];
    label: string; entidadeRelacionadaId?: string | null; nomeExibicao: string; fotoUrl?: string | null; capabilities: string[];
  }>;
  notificationReadiness: { serverConfigured: boolean; vapidPublicKey?: string | null };
  app: { version: string; minimumSupportedVersion?: string | null };
}

export async function fetchBootstrap(): Promise<AppBootstrap> {
  const data = await apiFetch<ApiBootstrap>("/api/app/bootstrap");
  return {
    identity: {
      id: data.identity.id,
      name: data.identity.nome,
      emailMasked: data.identity.emailMascarado,
      photoUrl: data.identity.fotoUrl ?? undefined
    },
    activeContextId: data.activeContextId,
    contexts: data.contexts.map(x => ({
      id: x.id,
      tenantId: x.tenantId,
      tenantName: x.tenantNome,
      experience: x.experiencia,
      label: x.label,
      relatedEntityId: x.entidadeRelacionadaId ?? undefined,
      displayName: x.nomeExibicao,
      photoUrl: x.fotoUrl ?? undefined,
      capabilities: x.capabilities
    })),
    notificationReadiness: {
      pushSupported: "serviceWorker" in navigator && "PushManager" in window,
      serverConfigured: data.notificationReadiness.serverConfigured,
      vapidPublicKey: data.notificationReadiness.vapidPublicKey ?? undefined
    },
    app: {
      version: data.app.version,
      minimumSupportedVersion: data.app.minimumSupportedVersion ?? undefined
    }
  };
}
